"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_quill_1 = require("react-quill");
var Embed = react_quill_1.Quill.import("blots/embed");
var AudioBlot = /** @class */ (function (_super) {
    __extends(AudioBlot, _super);
    function AudioBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AudioBlot.create = function (value) {
        var node = _super.create.call(this);
        node.setAttribute("src", value.url);
        var audio = document.createElement("audio");
        audio.setAttribute("src", value.url);
        if (value.linkText) {
            node.setAttribute("data-link-text", value.linkText);
            node.addEventListener("click", function () {
                if (audio.paused) {
                    audio.play().catch(console.error);
                }
                else {
                    audio.load();
                }
            });
        }
        else {
            node.setAttribute("controls", "controls");
            audio.setAttribute("controls", "controls");
        }
        node.appendChild(audio);
        return node;
    };
    AudioBlot.value = function (node) {
        return {
            url: node.getAttribute("src"),
            linkText: node.getAttribute("data-link-text") || undefined,
        };
    };
    return AudioBlot;
}(Embed));
AudioBlot.blotName = "tgcsAudio";
AudioBlot.tagName = "tgcs-audio";
react_quill_1.Quill.register("formats/tgcsAudio", AudioBlot);
